import { useEffect, useState } from 'react';
import { useAppSelector } from '../../app/hooks';
import { selectIsAIAutoMode } from '../../redux/features/ai/ai.selector';
import { selectCurrentTaskAIStatus } from '../../redux/features/taskRouter/taskRouter.selector';

/**
 * Drives the left-card takeover expansion. On an AI-supervised takeover the
 * whole left card (transcript + reminder + AI status) expands to overlay the
 * left + center area; it auto-collapses when AI auto mode ends, plus a manual
 * close. Lifted out of LiveTranscriptCard so the card — not just the transcript
 * section — is what expands (keeping the reminder + AI status visible).
 */
const useTranscriptExpand = () => {
  const currentTaskAIStatus = useAppSelector(selectCurrentTaskAIStatus);
  const isAIAutoMode = useAppSelector(selectIsAIAutoMode);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    if (currentTaskAIStatus) {
      setIsExpanded(true);
    }
    // Mount-only, matching the original TranscriptSliderArea behavior.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isAIAutoMode && isExpanded) {
      setIsExpanded(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAIAutoMode]);

  return { isExpanded, setIsExpanded };
};

export default useTranscriptExpand;
